<template>
  <div class="d-flex position-relative cursor-pointer" data-testid="searchbar-game-item" @mousedown="onCardClick()">
    <v-container fluid v-if="game" class="px-1 pt-1 pb-1">
      <v-row>
        <v-col cols="12" class="d-flex py-0 body-2">
          <div class="d-flex justify-space-between w-100">
            <div class="d-flex">
              <DriblabCountryFlag
                :iso="game.lCC"
                className="mr-2"
              ></DriblabCountryFlag>
              <span
                class="body-2 primary--text text-center"
                >{{ game.lName }}</span
              >
            </div>
            <span class="body-2 text--darken-1 primary--text ml-5">{{
              game.date
            }}</span>
          </div>
        </v-col>
        <v-col cols="12" sm="10" offset-sm="2" class="d-flex py-0">
          <v-row>
            <v-col cols="2" class="py-1 d-flex justify-start align-center">
              <img
                :src="
                  'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' +
                  game.htId +
                  '.png'
                "
                :height="22"
                contain
                @error="onImageLoadFailure($event)"
              />
            </v-col>
            <v-col cols="3" class="py-0 pl-0 d-flex justify-start align-center">
              <router-link
                :to="'/team/' + game.htId"
                class="nav-link text-ellipsis"
              >
                <span class="body-2">{{ game.htName }}</span>
              </router-link>
            </v-col>
            <v-col cols="2" class="py-0 d-flex justify-center align-center">
              <div class="flex-grow-1 d-flex justify-end">
                <span class="body-2">{{ game.htScore }}</span>
              </div>
              <span class="px-2">-</span>
              <div class="flex-grow-1 d-flex justify-start">
                <span class="body-2">{{ game.atScore }}</span>
              </div>
            </v-col>
            <v-col cols="3" class="py-0 d-flex justify-end pr-0 align-center">
              <router-link
                :to="'/team/' + game.atId"
                class="nav-link text-ellipsis"
              >
                <span class="body-2">{{ game.atName }}</span>
              </router-link>
            </v-col>
            <v-col cols="2" class="py-1 d-flex justify-center align-center">
              <img
                :src="
                  'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' +
                  game.atId +
                  '.png'
                "
                :height="22"
                contain
                @error="onImageLoadFailure($event)"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DriblabCountryFlag from '../base/DriblabCountryFlag';

export default {
  name: "GameSearchItem",
  components: {
    DriblabCountryFlag
  },
  filters: {
  },
  created() {},
  props: {
    game: {
      type: Object,
      default: false,
    },
    allowRouter: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onCardClick() {
      if (this.allowRouter) {
        this.$router.push({ name: "game", params: { id: this.game.id } });
      }
    },
    onImageLoadFailure(event) {
      event.target.src = "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png";
    },
  },
};
</script>
<style lang="scss">
.v-application--is-ltr .v-data-footer__select .v-select {
  margin: 6px 0 6px 34px;
}
</style>
